<template>
    <form-row title="Property PIN number">
        <input-text
            class="w-1/3 lg:w-1/4"
            :value="property.property_pin"
            name="property_pin"
            placeholder="Code"
            :read_only="read_only"
        />
    </form-row>
</template>

<script>
export default {
    props: {
        property: {},
        read_only: { default: false },
    },
}
</script>
